var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebAnalysis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132.517,
    height: 120,
    viewBox: "0 0 132.517 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3f18aa;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "web_analysis",
    transform: "translate(-149 -2498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M90,120H42V108H54V96H12A12.034,12.034,0,0,1,0,84V12A12.034,12.034,0,0,1,12,0H120a12.035,12.035,0,0,1,12,12V75.135H120V12H12V84h95.5V96H78v12H90v12Z",
    transform: "translate(149 2498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    className: "cls-1",
    d: "M8.449,52.3a8.471,8.471,0,0,1-8.232-6.54A8.464,8.464,0,0,1,6.542,35.64a7.594,7.594,0,0,1,1.717-.212c.15,0,.3.006.446.017L23.134,12.409a7.391,7.391,0,0,1-.781-2.072A8.438,8.438,0,0,1,30.566,0,8.473,8.473,0,0,1,38.8,6.54,7.431,7.431,0,0,1,39,8.745l6.927,4.328v9.922L34.546,15.88a7.46,7.46,0,0,1-2.071.781,8,8,0,0,1-1.78.221c-.145,0-.288-.005-.425-.016L15.891,39.934a7.19,7.19,0,0,1,.772,2.031A8.439,8.439,0,0,1,8.449,52.3Z",
    transform: "translate(165.489 2525.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_zoom_in_24px",
    d: "M55.825,49.486H52.487L51.3,48.345A27.511,27.511,0,1,0,48.345,51.3l1.141,1.183v3.339l21.13,21.088,6.3-6.3Zm-25.356,0A19.017,19.017,0,1,1,49.486,30.469,18.992,18.992,0,0,1,30.469,49.486Z",
    transform: "translate(204.604 2519.1)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebAnalysis);
export default __webpack_public_path__ + "static/media/web_analysis.c7a06141d9afe3a95fff8981389b4536.svg";
export { ForwardRef as ReactComponent };